/// Used for rounding numbers
export default class RoundingUtility {
  /// Round the number to 2 decimal places
  static round(num: number) {
    const roundedNum = Math.round(Number(num + "e2"));
    return Number(roundedNum + "e-2");
  }
}
